import React from "react";

const PriceProduct2 = () => {
  return (
    <section className="st-price-section py-8 sm:py-16 md:py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 md:px-16">
        <div className="mb-8 text-center">
          <h2 className="st-font-display st-price-title text-5xl leading-tight sm:text-6xl md:text-7xl lg:text-8xl">
            <span className="font-bold">Selangkah</span>
            <span className="font-normal italic"> Lebih </span>
            <span className="font-bold">Dekat</span>
            <span className="font-normal italic"> Menuju </span>
            <span className="font-bold">Impianmu</span>
          </h2>
        </div>
        <div className="mb-6 text-center">
          <p className="st-font-body st-price-subtitle text-lg sm:text-2xl md:text-3xl">
            Beasiswa, karier, atau kuliah luar negeri, semua dimulai dari sini!
          </p>
        </div>
        <div className="mb-12 flex justify-center">
          <div className="st-price-badge rounded-full px-7 py-2 sm:px-8 sm:py-3">
            <p className="st-font-body font-bold text-sm uppercase tracking-wide sm:text-base md:text-lg">
              🔥 Promo Batch Ini
            </p>
          </div>
        </div>
        <div className="mb-8 text-center">
          <p className="st-font-body st-price-normal text-2xl line-through sm:text-3xl md:text-4xl lg:text-5xl">
            Harga Normal: Rp 2.000.000
          </p>
        </div>
        <div className="mb-6 text-center">
          <p className="st-font-body st-price-label text-xl font-normal uppercase tracking-widest sm:text-2xl md:text-3xl">
            Harga Hari Ini
          </p>
        </div>
        <div className="mb-10 text-center">
          <p className="st-font-body st-price-main text-5xl font-bold sm:text-6xl md:text-7xl lg:text-8xl">
            497rb<span className="italic">!</span>
          </p>
        </div>
        <div className="text-center">
          <p className="st-font-body st-price-savings text-lg sm:text-xl md:text-2xl">
            <span className="font-normal">Hemat </span>
            <span className="st-price-savings-accent font-bold">Rp 1.503.000</span>
            <span className="font-normal"> — slot terbatas!</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PriceProduct2;
